import styled from "styled-components";

export const SearchApproverContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
  svg {
    font-size: 18px;
  }
`;

export const Container = styled.div`
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: ${props => (props.openDialog ? "flex" : "none")};
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  background-color: #f7f3ee;
`;

export const TimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TimeDivider = styled.div`
  font-weight: bold;
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-self: flex-end;
  width: 3%;
  margin: 0 5% 0 5%;
`;

export const TitleContainer = styled.div`
  font-size: 24px;
  display: flex;
  font-weight: bold;
`;

export const Title = styled.span`
  display: block;
  margin-left: 10px;
  font-size: 20px;
  margin-bottom: 20px;
`;

export const MainContainer = styled.div`
  display: flex;
  justify-self: flex-start;
  margin-bottom: auto;
  flex-direction: column;
  align-content: center;
  padding: 20px 10px 0 10px;
  gap: 10px;
`;

export const BackBtnContainer = styled.div`
  padding: 10px 10px 10px 10px;
  display: flex;
  align-items: center;
  align-self: flex-start;
  color: ${props => props.theme.colors.darkBlue};
  font-weight: bold;
  cursor: pointer;
  :active {
    color: #c0392b;
  }
`;

export const SteppersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex: 1;
  padding: 10px;
`;

export const VoterListsContainer = styled.div`
  overflow: auto;
  margin-top: 15px;
  width: 100%;
  height: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const VoterItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  width: 70%;
  padding: 2px 10px 2px 10px;
  :not(:last-child) {
    margin-bottom: 7px;
  }
  background-color: white;
  border: 2px solid #55bf8c;
  :hover {
    background-color: #000e36;
    border: 2px solid #31abfb;
    color: white;
  }
`;

export const VoterName = styled.h3`
  margin: 0;
  font-size: 13px;
`;

export const PlusIcon = styled.i`
  color: #55bf8c;
  :active {
    transform: scale(0.9);
    color: white;
  }
`;

export const SelectedVoterContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
`;

export const SelectedVoterTitleContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: start;
  margin-bottom: 10px;
`;

export const SelectedVoterTitle = styled.h1`
  font-size: 20px;
  margin: 0;
`;

export const MinusIcon = styled.i`
  margin-right: 10px;
  color: #55bf8c;
  :active {
    transform: scale(0.9);
    color: white;
  }
`;

export const UpAndDownContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

export const UpAndDownIcon = styled.i`
  :last-child {
    margin-top: 10%;
  }
  :active {
    color: #a29bfe;
  }
`;

export const SubmitBtn = styled.div`
  position: fixed;
  color: white;
  background-color: #e65122;
  border-radius: 20px;
  bottom: 8%;
  font-weight: bold;
  padding: 8px 40px 8px 40px;
  right: 6%;
  :active {
    background-color: #2d3436;
    transform: scale(0.95);
  }
`;
